<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Organisation" />
            <LesOrganisations />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesOrganisations from './LesOrganisations.vue';


export default {
    name: 'LesTuteursPage',
    components: {
        NavBar,
        PageTitle,
        LesOrganisations,
        FooterComp,
    }
}
</script>